module.exports = __webpack_public_path__ + "img/WOLT_WM_TIPPSPIEL.eea14264.png";